<template>
  <GmapMap
    ref="mapRef"
    :center="center"
    :options="options"
    :zoom="zoom"
    :style="{
      width: '100% !important',
      height: '100% !important',
    }"
  >
    <GmapMarker
      v-for="(m, index) in markers"
      :key="index"
      :clickable="markers[index].label === NavigationState.END"
      :draggable="false"
      :position="markers[index].position"
      :icon="markers[index].icon"
      @click="redirectGoogleMapsNavigation"
    />
  </GmapMap>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { gmapApi } from "vue2-google-maps";
import { NavigationState } from '@/const/navigation';
import { MessageBox } from 'mint-ui';

export default {
  name: "DistributorOrderMap",
  components: {
    MessageBox
  },
  data() {
    return {
      NavigationState: NavigationState,
      center: {
        lat: 0,
        lng: 0,        
      },
      location: {
        lat: 0,
        lng: 0,
      },
      point_location: {
        lat: 0,
        lng: 0,
      },
      markers: [],
    };
  },
  props: {
    point: {
      type: [Object, Boolean],
      default: function() {
        return false;
      },
    },
    zoom: {
      type: Number,
      default: 13,
    },
    options: {
      type: Object,
      default: function() {
        return {
          minZoom: 13,
          maxZoom: 19,
          disableDoubleClickZoom: false,
          clickableIcons: false,
          disableDefaultUI: true,
          mapId: process.env.VUE_APP_GOOGLE_MAP_STYLE_ID,
        };
      },
    },
  },
  computed: {
    google: gmapApi,
    ...mapState({
      distributor_point: (state) => state.distributor.point,
      distributor: (state) => state.distributor.info,
    }),
  },
  watch: {
    point: {
      handler: function(val, oldval) {
        if (!val) {
          return;
        }

        // 尚未加載gmapapi成功
        if (!this.google) {
          return;
        }
  
        this.point_location.lat = parseFloat(val.lat);
        this.point_location.lng = parseFloat(val.lng);

        this.pushMarker(NavigationState.END, this.point_location, {
          url: require("@/assets/image/end-location.svg"),
          scaledSize: new this.google.maps.Size(50, 50),
          origin: new this.google.maps.Point(0, 0),
          anchor: new this.google.maps.Point(25, 50),
        });
      },
      immediate: true,
      deep: true,
    },
    distributor: {
      handler: function(val, oldval) {
        if (! val) {
          return;
        }

        // 尚未加載gmapapi成功
        if (!this.google) {
          return;
        }

        this.location.lat = parseFloat(val.lat);
        this.location.lng = parseFloat(val.lng);

        this.pushMarker(NavigationState.START, this.location, {
          url: require("@/assets/image/start-location.svg"),
          scaledSize: new this.google.maps.Size(50, 50),
          origin: new this.google.maps.Point(0, 0),
          anchor: new this.google.maps.Point(25, 50),
        });
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.center = this.location
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.renderChangeAddressMarkerButtonElement(map);
    });
  },
  methods: {
    ...mapMutations({
      distributorPoint: "distributorPoint",
    }),
    pushMarker(label, position, icon) {
      const markerIndex = this.markers.findIndex((val) => val.label === label);
      if (markerIndex === -1) {
        this.markers.push({ label, position, icon });
      } else {
        this.markers[markerIndex].position = position;
      }
    },
    redirectGoogleMapsNavigation() {

      MessageBox.confirm("要前往 Google 導航嗎？", "導航")
        .then((action) => {
          const searchParams = new URLSearchParams(window.location.search);
          const params = {
            destination: Object.values(this.point_location).join(','),
            travelmode: "driving",
            dir_action: "navigate"
          }

          for(let key in params) {
            searchParams.set(key, params[key])
          }

          window.location.href  = "https://www.google.com/maps/dir/?api=1&" + searchParams.toString()
        })
        .catch((result) => {
          console.log('cancel: ', result)
        })

      // 判斷 MessageBox 處理 Clickoutside 的部份
      let messageBoxZindex = undefined
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutationRecord) => {
          const zindex = parseInt(mutationRecord.target.style.getPropertyValue('z-index'))
          if (messageBoxZindex === undefined) {
            messageBoxZindex = zindex
          }
          if (messageBoxZindex > zindex) {
            mutationRecord.target.remove()
          }
        })
      })

      try {
        observer.observe(document.querySelector('.v-modal'), {
          attributes: true,
          attributeFilter: ['style']
        })
      } catch (e) {
        if (e instanceof TypeError) {}
      }
    },
    // 渲染 - 按鈕元素 - Map Center 恢復
    renderChangeAddressMarkerButtonElement(map) {
      const controlUI = document.createElement("div");
      controlUI.id = "button_current_position_marker";

      const _this = this;

      controlUI.addEventListener("click", function(evt) {
        map.setCenter(_this.location)
        map.setZoom(17)
      });

      map.controls[this.google.maps.ControlPosition.RIGHT_BOTTOM].push(
        controlUI
      );
    },
  },
};
</script>
<style>
#button_current_position_marker {
  width: 40px;
  height: 40px;
  border-radius: 80%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  background: url("../../../assets/image/gps-location.svg"), -o-linear-gradient(rgba(250, 128, 10, 1), rgba(246, 0, 0, 1));
  background: url("../../../assets/image/gps-location.svg"), -moz-linear-gradient(rgba(250, 128, 10, 1), rgba(246, 0, 0, 1));
  background: url("../../../assets/image/gps-location.svg"), linear-gradient(rgba(250, 128, 10, 1), rgba(246, 0, 0, 1));
  background: url("../../../assets/image/gps-location.svg"), -webkit-linear-gradient(rgba(250, 128, 10, 1),rgba(246, 0, 0, 1));
  margin-bottom: 150px;
  margin-right: 20px;
  background-size: 100% 100%;
}
</style>
